module.exports = __webpack_public_path__ + "assets/img/news-bj.68f82128.png";